export enum ProductApplicationSetupActionType {
  SetTabToDelete = 'productApplicationSetup/setTabToDelete',
}
